import * as React from 'react'

import { Slider } from '@mui/material';

const minSat = 100*1000;

function descaleFromSatoshi(satoshi: number): number {
  return Math.log10(satoshi/minSat);
}


function scaleToSatoshis(base: number): number {
  return 10**base * minSat;
}

function getLabel(satoshi: number): string {
  if (satoshi < 1000*1000) {
    return `${satoshi/1000}K`;
  } else {
    return `${satoshi/(1000*1000)}M`;
  }
}


const scales = [0,1,2,3];

const amountSatMarks = new Map<number, {satoshi: number, label: string}>(
  scales.map(scale => {
    const satoshi = scaleToSatoshis(scale);
    return [
      scale,
      {
        satoshi: satoshi,
        label: getLabel(satoshi)
      }
    ]
  })
);



const marks = Array.from(amountSatMarks.entries()).map(([key, val]) => {
  return {
    value: key,
    label: val.label
  };
})



type Props = {
  satoshi: number,
  onChange: (newSatoshi: number) => any,
  onChangeCommited?: (newSatoshi: number) => any
}

const LiquidityAdSlider: React.FC<Props> = ({ satoshi, onChange, onChangeCommited=(newSats)=>undefined }: Props) => {
  const initialValue = descaleFromSatoshi(satoshi);
  const [value, setValue] = React.useState<number>(initialValue);

  React.useEffect(() => {
    const newVal = descaleFromSatoshi(satoshi);
    setValue(newVal);
  }, [satoshi]);

  function onNewValue(newVal: number) {
    const satoshi = scaleToSatoshis(newVal);
    onChange(satoshi)
  }

  function onNewValueCommited(newVal: number) {
    const satoshi = scaleToSatoshis(newVal);
    onChangeCommited(satoshi)
  }

  return (
    <Slider
    value={value}
    min={Math.min(...scales)}
    step={0.1}
    max={Math.max(...scales)}
    marks={marks}
    scale={val => scaleToSatoshis(val)}
    onChange={(_, newVal) => onNewValue(newVal as number)}
    aria-labelledby="non-linear-slider"
    sx={{
      '& .MuiSlider-markLabel': {
        color: '#9ca3af',
        fontSize: '12px'
      }
    }}
    onChangeCommitted={(_, newVal) => onNewValueCommited(newVal as number)}
  />
  );
}

export default LiquidityAdSlider;

